export default __webpack_public_path__ + "static/media/logo.19a75332.svg";